import { render, staticRenderFns } from "./CodeBtn.vue?vue&type=template&id=93a8d4ae"
import script from "./CodeBtn.vue?vue&type=script&lang=ts"
export * from "./CodeBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports